'use strict';

/**
 * Initializes all event handlers and AJAX interactions
 * related to the delivery date popup functionality.
 */
const initEstimatedDeliveryDate = function () {
    const $document = $(document);
    const $body = $('body');
    let updateDeliveryDate = true;

    // Handles click on estimated delivery date trigger button
    $document.on('click', '.product-delivery-date-slider', function () {
        const $this = $(this);
        const pid = $('.product-detail').first().data('pid');

        if (pid) {
            if (updateDeliveryDate) {
                // Load estimated delivery date overlay only once
                $.spinner().start();
                $.ajax({
                    url: $this.data('action'),
                    type: 'POST',
                    data: { pid: pid },
                    success: function (response) {
                        if (!response.error) {
                            // Remove any existing slider before appending new one
                            $('#delivery-date-overlay-slider').remove();
                            // Append rendered HTML from server
                            $body.append($.parseHTML(response.renderedTemplate));
                            $('.delivery-date-results-list').empty();
                            // Trigger custom select UI init
                            $document.trigger('customSelectInit');
                            // Open the estimated delivery date slider
                            $document.trigger('openSlider', {
                                target: '#delivery-date-overlay-slider',
                            });
                            // Prevent reloading overlay until variation changes
                            updateDeliveryDate = false;
                        }
                        $.spinner().stop();
                    },
                });
            } else {
                // Empty before open the slider
                $('.delivery-date-results-list').empty();
                $('.service-delivery-date-slider-body .search-input').val('');

                // If already loaded, just reopen the existing slider
                $document.trigger('openSlider', {
                    target: '#delivery-date-overlay-slider',
                });
            }
        }
    });

    // Handles search event for zip code in estimated delivery date slider
    $document.on('click', '.service-delivery-date-slider-body button.search-btn', function (event) {
        event.preventDefault();
        const $this = $(this);
        const pid = $('.product-detail').first().data('pid');
        const $inputField = $('.service-delivery-date-slider-body .search-input').first();
        const zipCode = $inputField.val().trim();
        $inputField.closest('.service-delivery-date-slider-body').find('.error-message').remove();

        if (pid) {
            $.spinner().start();
            if (zipCode) {
                $.ajax({
                    url: $this.data('action'),
                    type: 'POST',
                    data: {
                        zip: zipCode,
                        pid: pid,
                        displayLocation: 'pdp',
                    },
                    success: function (response) {
                        // Display estimated delivery dates based on zip code
                        $('.delivery-date-results-list').empty().html(response.renderedTemplate);
                    },
                });
            }
            $.spinner().stop();
        }
    });
};

module.exports = {
    initEstimatedDeliveryDate: initEstimatedDeliveryDate,
};
